import { updateTagLink } from 'api/Tags';

import { iaRa } from 'lib/helpers/utility';

const { showAlert } = require('components/shared/Alert/Alert');

const mergeTags = (existingTags, newTags, mode) => {
  let updatedTags = structuredClone(existingTags || []);
  if (mode === 'remove') {
    updatedTags = updatedTags.filter((tag) => !newTags.some((r) => r.tag_id === tag?.tag_id));
  }
  if (mode === 'add') {
    const addedTags = newTags?.flatMap((t) => t);
    const uniqueTags = addedTags.filter(
      (newTag) => !updatedTags.some((existing) => existing?.tag_id === newTag?.tag_id)
    );
    updatedTags = [...updatedTags, ...uniqueTags];
  }
  if (mode === 'update') {
    const addedTags = newTags?.flatMap((t) => t);
    const filterOldPositions = updatedTags?.filter(
      (tag) => !addedTags.some((addedTag) => addedTag?.tag_id === tag?.tag_id)
    );
    updatedTags = [...filterOldPositions, ...addedTags];
  }
  return updatedTags;
};

export const updateTagLinks = async ({
  navigate = null,
  queryClient = null,
  id = null,
  tags = [],
  mode = '',
  query = {},
  fromTable = false,
  refTable = '',
  isInvalidate = false
}) => {
  try {
    const result = await updateTagLink(navigate, {
      id,
      tags,
      mode,
      refTable
    });
    if (result?.code === 0) {
      if (!fromTable) {
        const queryUpdate = (oldData) => {
          try {
            const newData = oldData?.[query?.object]?.map((p) => {
              if (refTable === 'claim') {
                const foundClaim = p?.claims?.find((c) => c?.id === parseInt(id));
                if (!foundClaim) return p;

                const updatedClaims = iaRa(p?.claims)?.map((c) => {
                  if (c?.id !== parseInt(id)) return c;

                  const updatedTags = mergeTags(c?.tagLinks, result?.tags, mode);

                  return { ...c, tagLinks: updatedTags };
                });

                return { ...p, claims: updatedClaims };
              }
              if (p?.id !== parseInt(id)) {
                return p;
              }

              const updatedTags = mergeTags(p?.tagLinks, result?.tags, mode);

              return {
                ...p,
                tagLinks: updatedTags
              };
            });

            return {
              ...oldData,
              [query?.object]: newData
            };
          } catch (error) {
            showAlert({
              title: 'Tags update failed',
              message: error ?? 'Something went wrong',
              color: 'danger'
            });
          }
        };
        if (!isInvalidate) {
          if (query.multiple) {
            query?.keys?.forEach((key) => {
              queryClient.setQueriesData(key, queryUpdate);
            });
          } else {
            queryClient.setQueriesData(query?.keys, queryUpdate);
          }

          if (query.invalidateKeys) {
            query.invalidateKeys.forEach((key) => {
              queryClient.invalidateQueries(key);
            });
          }
        } else {
          if (query.multiple) {
            query?.keys?.forEach((key) => {
              queryClient.invalidateQueries(key);
            });
          } else {
            queryClient.invalidateQueries(query?.keys);
          }
        }
      } else {
        if (query.multiple) {
          query?.keys?.forEach((key) => {
            queryClient.invalidateQueries(key);
          });
        } else {
          queryClient.invalidateQueries(query?.keys);
        }
      }
    }
  } catch (error) {
    showAlert({
      title: 'Tags update failed',
      message: error ?? 'Something went wrong',
      color: 'danger'
    });
  }
};
